import { SIDEMENU_TOGGLE } from "../constants";

export default function sideMenuReducer(state = false, action) {
  switch (action.type) {
    // Register User
    case SIDEMENU_TOGGLE:
      return action.payload;

    default:
      return state;
  }
}
